import { render, staticRenderFns } from "./SmsWorkflowList.vue?vue&type=template&id=24f8013a&scoped=true&"
import script from "./SmsWorkflowList.vue?vue&type=script&lang=js&"
export * from "./SmsWorkflowList.vue?vue&type=script&lang=js&"
import style0 from "./SmsWorkflowList.vue?vue&type=style&index=0&id=24f8013a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8013a",
  null
  
)

component.options.__file = "SmsWorkflowList.vue"
export default component.exports